import React, { Fragment } from 'react'
import { string, array, func, number, bool, object } from 'prop-types'
import ResultsContainer from '../components/results/Container'
import withResults from '../hoc/withResults'
import { PROJECTS } from '../utils/constants'

const ScreensResultsProjects = ({
  results,
  widgetsAreLoading,
  widgets,
  totalDocs,
  resultsAreLoading,
  lastQueryUsed,
  query,
  error,
  filters,
  requestResults,
  ...rest
}) => {
  return (
    <Fragment>
      {!error && (
        <ResultsContainer
          aggregationActive={PROJECTS}
          isLoading={resultsAreLoading}
          query={query}
          lastQueryUsed={lastQueryUsed}
          results={results}
          totalCount={totalDocs}
          widgets={widgets}
          widgetsAreLoading={widgetsAreLoading}
          filters={filters}
          requestResults={requestResults}
          {...rest}
        />
      )}
    </Fragment>
  )
}

ScreensResultsProjects.propTypes = {
  results: array,
  widgetsAreLoading: bool,
  widgets: object,
  totalDocs: number,
  resultsAreLoading: bool,
  lastQueryUsed: string,
  query: string,
  error: bool,
  filters: object,
  requestResults: func
}

export default withResults(ScreensResultsProjects, PROJECTS)
